var map = {
	"./A/index.js": 87,
	"./about-banner/index.js": 89,
	"./footer/index.js": 91,
	"./header/index.js": 93,
	"./index.js": 53,
	"./industrial-banner/index.js": 95,
	"./investor-banner/index.js": 97,
	"./map/index.js": 99,
	"./page/index.js": 101,
	"./service-banner/index.js": 103,
	"./subsidiary-banner/index.js": 105,
	"./telent-banner/index.js": 107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;